import React from 'react';

const EmployeeList = ({ employees, userRole, onUpdate, onDelete, feedbacks }) => {
  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this employee?')) {
      onDelete(id);
    }
  };

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="text-xl font-semibold text-gray-900">Employee Directory</h2>
        <span className="text-sm text-gray-500">{employees.length} employees</span>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Department</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Designation</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
              <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {employees.length === 0 ? (
              <tr>
                <td colSpan="6" className="px-4 py-6 text-center text-sm text-gray-500">
                  No employees available.
                </td>
              </tr>
            ) : (
              employees.map((employee) => (
                <tr key={employee.id}>
                  <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">{employee.name}</td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">{employee.email}</td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">{employee.department}</td>
                  <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">{employee.designation}</td>
                  <td className="px-4 py-4 whitespace-nowrap">
                    <span className={`inline-flex rounded-full px-2 text-xs font-semibold ${employee.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`}>
                      {employee.status}
                    </span>
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-right text-sm font-medium space-x-2">
                    {['hr', 'admin', 'superadmin'].includes(userRole) && (
                      <button
                        type="button"
                        onClick={() => onUpdate({ ...employee, status: employee.status === 'active' ? 'inactive' : 'active' })}
                        className="text-indigo-600 hover:text-indigo-900"
                      >
                        Toggle Status
                      </button>
                    )}
                    {['hr', 'admin', 'superadmin'].includes(userRole) && (
                      <button
                        type="button"
                        onClick={() => handleDelete(employee.id)}
                        className="text-red-600 hover:text-red-900"
                      >
                        Delete
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {feedbacks && feedbacks.length > 0 && (
        <div className="mt-6">
          <h3 className="text-lg font-semibold text-gray-900">Latest Feedback</h3>
          <ul className="mt-4 space-y-3">
            {feedbacks.slice(0, 3).map((feedback) => (
              <li key={feedback.id} className="border border-gray-200 rounded-lg p-4 bg-gray-50">
                <p className="text-sm text-gray-700">{feedback.feedback}</p>
                <p className="mt-2 text-xs text-gray-500">{feedback.reviewer} · {feedback.date}</p>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default EmployeeList;
//     { 
//       id: 2, 
//       name: 'Aman Verma', 
//       email: 'aman@aizops.com', 
//       role: 'employee', 
//       department: 'Software Development', 
//       position: 'MERN Stack Developer',
//       joinDate: '2023-02-20', 
//       status: 'active',
//       phone: '+91 98765 43211',
//       dob: '1994-07-22',
//       location: 'Delhi',
//       employeeId: 'EMP002',
//       bloodGroup: 'B+',
//       address: 'Delhi, India',
//       emergencyContact: '+91 98765 43211',
//       dateOfBirth: '1994-07-22',
//       gender: 'Male',
//       maritalStatus: 'Married',
//       nationality: 'Indian',
//       employeeType: 'Full-Time',
//       workLocation: 'Delhi',
//       workMode: 'Hybrid',
//       salary: '900000',
//       ctc: '1350000',
//       bankAccountNumber: '1234567891',
//       bankName: 'HDFC',
//       ifscCode: 'HDFC0012345',
//       highestQualification: 'M.Tech',
//       skills: 'MERN, AWS, Docker',
//       totalExperience: '4',
//       documents: {
//         tenthMarksheet: true,
//         twelfthMarksheet: true,
//         graduationCertificate: true,
//         experienceLetter: true,
//         relievingLetter: true,
//         salarySlips: true
//       }
//     },
//     { 
//       id: 3, 
//       name: 'Saurav Kumar', 
//       email: 'saurav@aizops.com', 
//       role: 'employee', 
//       department: 'Marketing', 
//       position: 'Digital Marketing Specialist',
//       joinDate: '2023-03-10', 
//       status: 'active',
//       phone: '+91 98765 43212',
//       dob: '1996-11-08',
//       location: 'Bangalore',
//       employeeId: 'EMP003',
//       bloodGroup: 'A+',
//       address: 'Bangalore, India',
//       emergencyContact: '+91 98765 43212',
//       dateOfBirth: '1996-11-08',
//       gender: 'Male',
//       maritalStatus: 'Single',
//       nationality: 'Indian',
//       employeeType: 'Full-Time',
//       workLocation: 'Bangalore',
//       workMode: 'Remote',
//       salary: '700000',
//       ctc: '1050000',
//       bankAccountNumber: '1234567892',
//       bankName: 'ICICI',
//       ifscCode: 'ICICI0012345',
//       highestQualification: 'MBA',
//       skills: 'SEO, SEM, Social Media Marketing',
//       totalExperience: '2',
//       documents: {
//         tenthMarksheet: true,
//         twelfthMarksheet: true,
//         graduationCertificate: true
//       }
//     },
//     { 
//       id: 4, 
//       name: 'Sanjiv Singh', 
//       email: 'sanjiv@aizops.com', 
//       role: 'hr', 
//       department: 'Human Resources', 
//       position: 'HR Manager',
//       joinDate: '2023-01-05', 
//       status: 'active',
//       phone: '+91 98765 43213',
//       dob: '1990-12-25',
//       location: 'Pune',
//       employeeId: 'EMP004',
//       bloodGroup: 'AB+',
//       address: 'Pune, India',
//       emergencyContact: '+91 98765 43213',
//       dateOfBirth: '1990-12-25',
//       gender: 'Male',
//       maritalStatus: 'Married',
//       nationality: 'Indian',
//       employeeType: 'Full-Time',
//       workLocation: 'Pune',
//       workMode: 'On-site',
//       salary: '1200000',
//       ctc: '1800000',
//       bankAccountNumber: '1234567893',
//       bankName: 'Axis Bank',
//       ifscCode: 'AXIS0012345',
//       highestQualification: 'MBA',
//       skills: 'Recruitment, Employee Relations, Performance Management',
//       totalExperience: '8',
//       documents: {
//         tenthMarksheet: true,
//         twelfthMarksheet: true,
//         graduationCertificate: true,
//         experienceLetter: true,
//         relievingLetter: true,
//         salarySlips: true
//       }
//     },
//     { 
//       id: 5, 
//       name: 'Dr. Apj Abdul Kalam', 
//       email: 'kalam@aizops.com', 
//       role: 'employee', 
//       department: 'R&D', 
//       position: 'Chief Scientist',
//       joinDate: '2023-01-15', 
//       status: 'active',
//       phone: '+91 98765 43214',
//       dob: '1931-10-15',
//       location: 'Chennai',
//       employeeId: 'EMP005',
//       bloodGroup: 'O-',
//       address: 'Chennai, India',
//       emergencyContact: '+91 98765 43214',
//       dateOfBirth: '1931-10-15',
//       gender: 'Male',
//       maritalStatus: 'Married',
//       nationality: 'Indian',
//       employeeType: 'Full-Time',
//       workLocation: 'Chennai',
//       workMode: 'On-site',
//       salary: '2000000',
//       ctc: '3000000',
//       bankAccountNumber: '1234567894',
//       bankName: 'Canara Bank',
//       ifscCode: 'CANB0012345',
//       highestQualification: 'PhD',
//       skills: 'Aerospace, Research, Innovation',
//       totalExperience: '40',
//       documents: {
//         tenthMarksheet: true,
//         twelfthMarksheet: true,
//         graduationCertificate: true,
//         experienceLetter: true,
//         relievingLetter: true,
//         salarySlips: true
//       }
//     },
//     { 
//       id: 6, 
//       name: 'John Doe', 
//       email: 'john@aizops.com', 
//       role: 'manager', 
//       department: 'IT', 
//       position: 'IT Manager',
//       joinDate: '2023-02-20', 
//       status: 'active',
//       phone: '+91 98765 43215',
//       dob: '1988-05-20',
//       location: 'Hyderabad',
//       employeeId: 'EMP006',
//       bloodGroup: 'A-',
//       address: 'Hyderabad, India',
//       emergencyContact: '+91 98765 43215',
//       dateOfBirth: '1988-05-20',
//       gender: 'Male',
//       maritalStatus: 'Married',
//       nationality: 'Indian',
//       employeeType: 'Full-Time',
//       workLocation: 'Hyderabad',
//       workMode: 'Hybrid',
//       salary: '1500000',
//       ctc: '2250000',
//       bankAccountNumber: '1234567895',
//       bankName: 'Kotak Bank',
//       ifscCode: 'KOTAK0012345',
//       highestQualification: 'B.Tech',
//       skills: 'IT Infrastructure, Team Management, Cloud Computing',
//       totalExperience: '10',
//       documents: {
//         tenthMarksheet: true,
//         twelfthMarksheet: true,
//         graduationCertificate: true,
//         experienceLetter: true,
//         relievingLetter: true,
//         salarySlips: true
//       }
//     },
//     { 
//       id: 7, 
//       name: 'Jane Smith', 
//       email: 'jane@aizops.com', 
//       role: 'hr', 
//       department: 'HR', 
//       position: 'HR Executive',
//       joinDate: '2023-03-10', 
//       status: 'active',
//       phone: '+91 98765 43216',
//       dob: '1992-08-30',
//       location: 'Mumbai',
//       employeeId: 'EMP007',
//       bloodGroup: 'B-',
//       address: 'Mumbai, India',
//       emergencyContact: '+91 98765 43216',
//       dateOfBirth: '1992-08-30',
//       gender: 'Female',
//       maritalStatus: 'Single',
//       nationality: 'Indian',
//       employeeType: 'Full-Time',
//       workLocation: 'Mumbai',
//       workMode: 'On-site',
//       salary: '600000',
//       ctc: '900000',
//       bankAccountNumber: '1234567896',
//       bankName: 'SBI',
//       ifscCode: 'SBIN0065432',
//       highestQualification: 'MBA',
//       skills: 'Recruitment, Onboarding, HR Policies',
//       totalExperience: '3',
//       documents: {
//         tenthMarksheet: true,
//         twelfthMarksheet: true,
//         graduationCertificate: true
//       }
//     },
//     { 
//       id: 8, 
//       name: 'Mike Johnson', 
//       email: 'mike@aizops.com', 
//       role: 'admin', 
//       department: 'Administration', 
//       position: 'System Administrator',
//       joinDate: '2023-01-05', 
//       status: 'active',
//       phone: '+91 98765 43217',
//       dob: '1985-12-10',
//       location: 'Delhi',
//       employeeId: 'EMP008',
//       bloodGroup: 'AB-',
//       address: 'Delhi, India',
//       emergencyContact: '+91 98765 43217',
//       dateOfBirth: '1985-12-10',
//       gender: 'Male',
//       maritalStatus: 'Married',
//       nationality: 'Indian',
//       employeeType: 'Full-Time',
//       workLocation: 'Delhi',
//       workMode: 'On-site',
//       salary: '1000000',
//       ctc: '1500000',
//       bankAccountNumber: '1234567897',
//       bankName: 'HDFC',
//       ifscCode: 'HDFC0065432',
//       highestQualification: 'B.Sc',
//       skills: 'System Administration, Networking, Security',
//       totalExperience: '12',
//       documents: {
//         tenthMarksheet: true,
//         twelfthMarksheet: true,
//         graduationCertificate: true,
//         experienceLetter: true,
//         relievingLetter: true,
//         salarySlips: true
//       }
//     },
//   ];

//   // Use props employees or default data
//   const [localEmployees, setLocalEmployees] = useState(() => {
//     if (propEmployees && Array.isArray(propEmployees) && propEmployees.length > 0) {
//       return propEmployees;
//     }
//     return defaultEmployees;
//   });

//   // Get unique departments safely
//   const getUniqueDepartments = () => {
//     const depts = localEmployees.map(emp => emp.department).filter(Boolean);
//     return ['all', ...new Set(depts)];
//   };

//   const departments = getUniqueDepartments();
//   const roles = ['all', 'employee', 'manager', 'hr', 'admin'];

//   // Filter employees
//   const filteredEmployees = localEmployees.filter(emp => {
//     const matchesSearch = searchTerm === '' || 
//       (emp.name && emp.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
//       (emp.email && emp.email.toLowerCase().includes(searchTerm.toLowerCase())) ||
//       (emp.position && emp.position.toLowerCase().includes(searchTerm.toLowerCase())) ||
//       (emp.employeeId && emp.employeeId.toLowerCase().includes(searchTerm.toLowerCase()));
    
//     const matchesRole = filterRole === 'all' || emp.role === filterRole;
//     const matchesDepartment = filterDepartment === 'all' || emp.department === filterDepartment;
    
//     return matchesSearch && matchesRole && matchesDepartment;
//   });

//   // Pagination
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredEmployees.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);

//   const getRoleBadge = (role) => {
//     const colors = {
//       superadmin: 'bg-red-100 text-red-700',
//       admin: 'bg-purple-100 text-purple-700',
//       hr: 'bg-blue-100 text-blue-700',
//       manager: 'bg-green-100 text-green-700',
//       employee: 'bg-gray-100 text-gray-700'
//     };
//     return colors[role] || colors.employee;
//   };

//   const handleViewProfile = (employee) => {
//     if (onViewProfile) {
//       onViewProfile(employee);
//     } else {
//       // Default view profile action
//       alert(`Viewing profile of ${employee.name}`);
//     }
//   };

//   const handleAddEmployee = (newEmployee) => {
//     const employeeWithId = {
//       ...newEmployee,
//       id: localEmployees.length + 1,
//       status: 'active',
//       createdAt: new Date().toISOString()
//     };
//     setLocalEmployees([...localEmployees, employeeWithId]);
//     setShowAddForm(false);
//     if (onUpdateEmployee) {
//       onUpdateEmployee(employeeWithId);
//     }
//     alert('Employee added successfully!');
//   };

//   const handleEditEmployee = (employee) => {
//     setSelectedEmployee(employee);
//     setShowEditForm(true);
//   };

//   const handleUpdateEmployee = (updatedEmployee) => {
//     const updatedEmployees = localEmployees.map(emp => 
//       emp.id === updatedEmployee.id ? { ...updatedEmployee, updatedAt: new Date().toISOString() } : emp
//     );
//     setLocalEmployees(updatedEmployees);
//     setShowEditForm(false);
//     setSelectedEmployee(null);
//     if (onUpdateEmployee) {
//       onUpdateEmployee(updatedEmployee);
//     }
//     alert('Employee updated successfully!');
//   };

//   const handleDeleteClick = (employee) => {
//     setEmployeeToDelete(employee);
//     setShowDeleteConfirm(true);
//   };

//   const confirmDelete = () => {
//     const updatedEmployees = localEmployees.filter(emp => emp.id !== employeeToDelete.id);
//     setLocalEmployees(updatedEmployees);
//     setShowDeleteConfirm(false);
//     setEmployeeToDelete(null);
//     if (onDeleteEmployee) {
//       onDeleteEmployee(employeeToDelete.id);
//     }
//     alert('Employee deleted successfully!');
//   };

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   // Don't render AddEmployee here - it will be handled by routing
//   // Instead, show a modal or navigate to add employee page
//   if (showAddForm) {
//     return <AddEmployee onAdd={handleAddEmployee} onCancel={() => setShowAddForm(false)} />;
//   }

//   if (showEditForm && selectedEmployee) {
//     return <AddEmployee onAdd={handleUpdateEmployee} editData={selectedEmployee} onCancel={() => setShowEditForm(false)} />;
//   }

//   return (
//     <div>
//       {/* Delete Confirmation Modal */}
//       {showDeleteConfirm && employeeToDelete && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-xl p-6 max-w-md w-full mx-4">
//             <div className="flex items-center justify-center mb-4">
//               <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
//                 <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
//                 </svg>
//               </div>
//             </div>
//             <h3 className="text-xl font-semibold text-center mb-2">Delete Employee</h3>
//             <p className="text-gray-600 text-center mb-4">
//               Are you sure you want to delete <strong>{employeeToDelete.name}</strong>? This action cannot be undone.
//             </p>
//             <div className="flex gap-3 justify-end">
//               <button onClick={() => setShowDeleteConfirm(false)} 
//                 className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition">
//                 Cancel
//               </button>
//               <button onClick={confirmDelete} 
//                 className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition">
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="flex justify-between items-center mb-6">
//         <div>
//           <h1 className="text-2xl font-bold text-gray-800">Employee Management</h1>
//           <p className="text-sm text-gray-500 mt-1">Manage and view all employee details</p>
//         </div>
//         {userRole && ['hr', 'admin', 'superadmin'].includes(userRole) && (
//           <button 
//             onClick={() => setShowAddForm(true)}
//             className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition flex items-center gap-2"
//           >
//             <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
//             </svg>
//             Add Employee
//           </button>
//         )}
//       </div>
      
//       <div className="bg-white rounded-xl shadow-sm">
//         <div className="p-4 border-b flex flex-wrap gap-4 justify-between">
//           <div className="flex flex-wrap gap-3">
//             <div className="relative">
//               <svg className="absolute left-3 top-2.5 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//               </svg>
//               <input
//                 type="text"
//                 placeholder="Search by name, email, ID or position..."
//                 className="pl-9 pr-4 py-2 border rounded-lg w-80 focus:outline-none focus:ring-2 focus:ring-indigo-500"
//                 value={searchTerm}
//                 onChange={(e) => {
//                   setSearchTerm(e.target.value);
//                   setCurrentPage(1);
//                 }}
//               />
//             </div>
//             <select
//               className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//               value={filterRole}
//               onChange={(e) => {
//                 setFilterRole(e.target.value);
//                 setCurrentPage(1);
//               }}
//             >
//               {roles.map(role => (
//                 <option key={role} value={role}>{role === 'all' ? 'All Roles' : role.toUpperCase()}</option>
//               ))}
//             </select>
//             <select
//               className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//               value={filterDepartment}
//               onChange={(e) => {
//                 setFilterDepartment(e.target.value);
//                 setCurrentPage(1);
//               }}
//             >
//               {departments.map(dept => (
//                 <option key={dept} value={dept}>{dept === 'all' ? 'All Departments' : dept}</option>
//               ))}
//             </select>
//           </div>
//           <div className="text-sm text-gray-500">
//             Showing {filteredEmployees.length} of {localEmployees.length} employees
//           </div>
//         </div>
        
//         <div className="overflow-x-auto">
//           <table className="w-full">
//             <thead className="bg-gray-50">
//               <tr>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Employee</th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contact</th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Role</th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Department</th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Position</th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Documents</th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-200">
//               {currentItems.map(emp => (
//                 <tr key={emp.id} className="hover:bg-gray-50 transition-colors">
//                   <td className="px-6 py-4">
//                     <div className="flex items-center gap-3">
//                       <div className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center text-indigo-600 font-bold">
//                         {emp.name ? emp.name.charAt(0) : '?'}
//                       </div>
//                       <div>
//                         <p className="text-sm font-medium text-gray-900">{emp.name || 'N/A'}</p>
//                         <p className="text-xs text-gray-500">ID: {emp.employeeId || `EMP00${emp.id}`}</p>
//                       </div>
//                     </div>
//                   </td>
//                   <td className="px-6 py-4">
//                     <p className="text-sm text-gray-600">{emp.email || 'N/A'}</p>
//                     <p className="text-xs text-gray-400">{emp.phone || 'N/A'}</p>
//                   </td>
//                   <td className="px-6 py-4">
//                     <span className={`text-xs px-2 py-1 rounded-full ${getRoleBadge(emp.role)}`}>
//                       {emp.role ? emp.role.toUpperCase() : 'N/A'}
//                     </span>
//                   </td>
//                   <td className="px-6 py-4 text-sm text-gray-600">{emp.department || 'N/A'}</td>
//                   <td className="px-6 py-4 text-sm text-gray-600">{emp.position || 'N/A'}</td>
//                   <td className="px-6 py-4">
//                     <div className="flex gap-1 flex-wrap">
//                       {emp.documents?.tenthMarksheet && (
//                         <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
//                           10th
//                         </span>
//                       )}
//                       {emp.documents?.twelfthMarksheet && (
//                         <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
//                           12th
//                         </span>
//                       )}
//                       {emp.documents?.graduationCertificate && (
//                         <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
//                           Grad
//                         </span>
//                       )}
//                       {emp.documents?.experienceLetter && (
//                         <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
//                           Exp
//                         </span>
//                       )}
//                     </div>
//                   </td>
//                   <td className="px-6 py-4">
//                     <span className="text-xs px-2 py-1 rounded-full bg-green-100 text-green-700 flex items-center gap-1 w-fit">
//                       <span className="w-1.5 h-1.5 bg-green-500 rounded-full"></span>
//                       Active
//                     </span>
//                   </td>
//                   <td className="px-6 py-4 text-sm">
//                     <button 
//                       onClick={() => handleViewProfile(emp)} 
//                       className="text-indigo-600 hover:text-indigo-800 mr-3 font-medium"
//                     >
//                       View
//                     </button>
//                     {userRole && ['hr', 'admin', 'superadmin'].includes(userRole) && (
//                       <>
//                         <button 
//                           onClick={() => handleEditEmployee(emp)}
//                           className="text-green-600 hover:text-green-800 mr-3 font-medium"
//                         >
//                           Edit
//                         </button>
//                         <button 
//                           onClick={() => handleDeleteClick(emp)}
//                           className="text-red-600 hover:text-red-800 font-medium"
//                         >
//                           Delete
//                         </button>
//                       </>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
        
//         {/* Pagination */}
//         {filteredEmployees.length > 0 && totalPages > 1 && (
//           <div className="px-6 py-4 border-t flex justify-between items-center">
//             <div className="text-sm text-gray-500">
//               Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredEmployees.length)} of {filteredEmployees.length} entries
//             </div>
//             <div className="flex gap-2">
//               <button
//                 onClick={() => paginate(currentPage - 1)}
//                 disabled={currentPage === 1}
//                 className={`px-3 py-1 border rounded-lg ${currentPage === 1 ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'hover:bg-gray-50'}`}
//               >
//                 Previous
//               </button>
//               {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
//                 let pageNum;
//                 if (totalPages <= 5) {
//                   pageNum = i + 1;
//                 } else if (currentPage <= 3) {
//                   pageNum = i + 1;
//                 } else if (currentPage >= totalPages - 2) {
//                   pageNum = totalPages - 4 + i;
//                 } else {
//                   pageNum = currentPage - 2 + i;
//                 }
//                 return (
//                   <button
//                     key={pageNum}
//                     onClick={() => paginate(pageNum)}
//                     className={`px-3 py-1 border rounded-lg ${currentPage === pageNum ? 'bg-indigo-600 text-white' : 'hover:bg-gray-50'}`}
//                   >
//                     {pageNum}
//                   </button>
//                 );
//               })}
//               <button
//                 onClick={() => paginate(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//                 className={`px-3 py-1 border rounded-lg ${currentPage === totalPages ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'hover:bg-gray-50'}`}
//               >
//                 Next
//               </button>
//             </div>
//           </div>
//         )}
        
//         {filteredEmployees.length === 0 && (
//           <div className="text-center py-12">
//             <svg className="w-16 h-16 mx-auto text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//             </svg>
//             <p className="text-gray-500">No employees found matching your search</p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default EmployeeList;